<template>
  <v-container fluid>

    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"

      absolute
    >
      <v-btn
        text
        @click="snackbar = false"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
      {{ message }}
    </v-snackbar>

    <div :class="paginatedFiles.length === 7 ? 'viewfarmer_box' : 'viewfarmer_box_empty'">
      <v-card

        max-width="100%"
      >

        <v-card-title v-if="canBeGenerated()" class="accent--text" style="font-size: 14px; font-weight:700;"> INITIATE CONVERSION OF FARMER FUNDS FROM USD TO KES</v-card-title>
        <v-card-title  v-if="canApproveConversion()" class="accent--text" style="font-size: 14px; font-weight:700;"> APPROVE CONVERSION OF FARMER FUNDS FROM USD TO KES</v-card-title>
        <!--                <v-divider class="mx-4"></v-divider>-->

        <div v-if="canBeGenerated()">
          <v-card-text>

            <v-form ref="editform" v-model="valid" lazy-validation no-gutters justify="space-around">
              <v-row
                no-gutters justify="space-around"
              >
                <v-col
                  class="d-flex justify-start"
                >

                  <!--                      <span class="accent&#45;&#45;text" style="font-size: 12px; font-weight:600;"> Deal Rate Code</span>-->
                  <v-text-field  type="number" label="Deal Rate Code" v-model="dealcode"></v-text-field>

                </v-col>
                <v-col
                  class="d-flex justify-end ml-10"
                >
                  <div class="warrant_box">


                  </div>
                </v-col>
                <v-col
                  class="d-flex justify-end"
                >
                  <v-btn color="primary" @click="setConversionRate(dealcode)">Submit</v-btn>
                </v-col>

              </v-row>

            </v-form>

          </v-card-text>

          <v-divider ></v-divider>
        </div>
        <v-card-title class="accent--text" style="font-size: 12px; font-weight:600;"> Conversion Rate History</v-card-title>
        <v-card-text>

          <table class="table">
            <thead class="thead">
            <tr>
              <th scope="col">Organization</th>
              <th scope="col">Deal Rate Code</th>
              <th scope="col">Rate</th>
              <th scope="col">Expiry Date</th>
              <th scope="col">Status</th>
              <th scope="col">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="history in filteredList" v-bind:key="history.id">
              <td> {{ history.grower !== null ? history.grower.organisationName : '' }}</td>
              <td> {{ history.rateCode }}</td>
              <td> {{ history.rate }}</td>
              <td>{{ history.expiryDate }}</td>
              <td>{{ history.status?.statusName }}</td>
              <td class="actions">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      text
                      icon
                      class="actions"
                    >
                      <v-icon class="secondary--text"> more_horiz</v-icon>
                    </v-btn>
                  </template>
                  <v-list v-if="canBeApproved(history)">
                    <v-list-item  @click="showConfirmDialog (history,'APPROVE')">
                      <v-list-item-title> Approve</v-list-item-title>
                    </v-list-item>
                    <v-list-item  @click="showConfirmDialog (history,'REJECT')">
                      <v-list-item-title> Reject</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
            </tbody>
          </table>
        </v-card-text>

        <v-card-actions>
          <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
          <v-spacer></v-spacer>
          <v-pagination
            v-model="page"
            :length="numberOfLinks"
            color="secondary"
                class="accent--text logoutbtn"
          ></v-pagination>
        </v-card-actions>
      </v-card>
    </div>
    <v-dialog v-model="confirmDialog" max-width="400">
      <v-card>
        <v-card-title class="body-2 primary--text font-weight-bold text-capitalize">{{ this.action }} Conversion Rate
        </v-card-title>

        <v-card-text class="primary--text">
          {{ confirmMessage }}
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="confirmDialog = false"
            class="font-weight-bold"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="accent--text logoutbtn"
            @click="approveRecord"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import themes from 'devextreme/ui/themes'

export default {
	name: 'ccarfUsdKesRate',
	data: function () {
		return {
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			history: [],
			totalFarmers: 0,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			editDialog: false,
			confirmDialog: false,
			permissions: [],
			dealcode: 0,
			organizations: [],
			organization: {
				id: '',
				organisationName: ''
			},
			disableFarmer: {},
			confirmMessage: '',
			fcsCode: '',
			cherry: 0.00,
			debt: 0.00,
			limit: 0.00,
			action: '',
			isFcs: ' '
		}
	},
	mounted () {
		this.getOrganizations()
		this.getHistory()

		this.permissions = store.state.user.roleId.permissions
		this.isFcs = store.state.user.organisation.organisationType.name === 'FARMER_SOCIETY'
		this.fcsCode = store.state.user?.organisation?.organisationCode
	},
	watch: {

		history () {
			this.paginatedFiles = this.paginationMethod(this.history, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.history.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.history, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.history.filter(hist => {
					return (hist.grower.organisationName !== null ? hist.grower.organisationName.toLowerCase().includes(this.search.toLowerCase()) : ''.toLowerCase().includes(this.search.toLowerCase())) || (hist.rateCode === null ? ''.toLowerCase().includes(this.search.toLowerCase()) : hist.rateCode.toLowerCase().includes(this.search.toLowerCase())) || hist.status.statusName.toLowerCase().includes(this.search.toLowerCase()) || hist.rate.includes(this.search)
				})
			}
		}
	},
	methods: {
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		ifFCS () {
			return this.isFcs
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		getHistory () {
			const url = config.serverURI + '/payment/conversionRate/history'
			axios.get(url)
				.then(response => {
					this.history = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},

		getOrganizations () {
			const url = config.serverURI + '/organization/getAll'
			axios.get(url)
				.then(response => {
					console.log('org response', response.data)
					this.organizations = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},
		updateOrganization () {
			const selectedOrganization = this.organizations.find(organization => organization.organisationName === this.organization?.organisationName)
			if (selectedOrganization) {
				console.log('Organization  Id>>>', selectedOrganization.id)
				console.log('Organization  Name>>>', selectedOrganization.organisationName)
				this.organization.organisationName = selectedOrganization.organisationName
				this.organization.id = selectedOrganization.id
			}
		},

		setConversionRate () {
			const url = config.serverURI + '/payment/conversionRate/update'
			axios.post(url, {
				rateCode: this.dealcode
			})
				.then(response => {
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						console.log('Error is ' + this.message)
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.getHistory()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred while processing your request'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		canBeApproved (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_CONVERSION_RATE')
		},
		canBeGenerated () {
			return this.hasPerm('CAN_CREATE_CONVERSION_RATE')
		},
    canApproveConversion() {
      return this.hasPerm('CAN_APPROVE_CONVERSION_RATE')
    },
		showConfirmDialog (item, action) {
			this.confirmDialog = true
			this.item = item
			this.action = action
			if (action === 'APPROVE') {
				this.confirmMessage = 'Do you want to Approve the conversion rate(' + item?.rate + ') set for Deal code ' + item?.rateCode + ' ?'
			} else if (action === 'REJECT') {
				this.confirmMessage = 'Do you want to Reject conversion rate(' + item?.rate + ')  for Deal Code ' + item?.rateCode + ' ?'
			} else {
				console.error(action + 'Action not supported')
			}
		},
		approveRecord () {
			const url = config.serverURI + '/payment/conversionRate/approve'
			axios.post(url, {
				id: this.item?.id,
				growerId: this.item?.grower?.id,
				action: this.action

			})
				.then(response => {
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						console.log('Error is ' + this.message)
						this.confirmDialog = false
						this.getHistory()
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.confirmDialog = false
					this.getHistory()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred while processing your request'
					this.snackbar = true
					this.snackbarColor = 'error'
					this.confirmDialog = false
					this.getHistory()
				})
		}

	}
}

</script>
<style>
.viewfarmer_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.viewfarmer_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}

</style>
